<template>

		<div class="pageBox topFixedSpace" id="pageBox" v-show="this.showPaper">
			<!--page start-->
			<div class="testing_answer">
				<div class="headerEle clearfix">
					<span class="countEle fl">
						完成 <strong>{{this.finishNum}}</strong> / {{this.totalNum}}题目
					</span>
					<div class="fr clockEle">
						{{this.timer}}
					</div>
					<span class="progress ab" style="width: 20%;"></span>
				</div>
				<div class="bodyEle">
					<!--题目 开始-->
					<div class="answerItem re" v-for="(question, idx) in questionList" v-show="curId === idx" >
						<span class="answerNum ab radius50">{{idx+1}}</span>
						<h1>{{question.question_title}}</h1>
						<p v-for="option in question.option_info">
							{{option.option_key}}、{{option.option_text}}
						</p>

						<h2>以上说法正确的是：</h2>

						<ul class="t" :qid="question.question_id">
							<li class="re radius3 radioItemEvent" :id="sel_option.paper_option_id" v-for="sel_option in question.option_select_info" v-on:click="setOption(question.question_id, sel_option.paper_option_id)">
								<span class="selectItem ab radius2">{{sel_option.paper_option_key}}</span>
								<div class="infor">
									{{sel_option.paper_option_value}}
								</div>
							</li>
						</ul>
					</div>
					<!--题目 结束-->
				</div>

				<div class="center btnGroup">
					<a class="pointer btnItem" v-on:click="nextQuestion" v-show="curId < (totalNum-1)">下一题</a>
					<a class="pointer btnItem" v-on:click="submitPaper" v-show="curId == (totalNum-1)">交卷</a>
				</div>

				<div class="cardSection clearfix">
					<img src="//images.jinku.com/newjk/h5/images/mobile/testing/cardIcon.png"  class="fl cardIcon">
					<span class="fl pointer cardBtn cardBtnEvent active">答题卡</span>
				</div>
				<div class="cardListBox cardListEvent">
					<ul class="clearfix" >
						<!--未做题目 给li添加 active 样式-->
						<li class="fl radius2 answer_sheet active " v-for="(questionId, idx) in questionIdArr" :ans_qid="questionId">
							<a v-on:click="selQuestion(idx)">{{idx+1}}</a>
						</li>

					</ul>
				</div>

			</div>
			<!--page end-->



			<!--试卷未通过-->
			<div class="testingResult publicPop pop17" style="display: block;" v-show="this.paperFail">
				<div class="popContainer" style="margin-left: -182px; margin-top: -201px;">
					<input type="button" class="closeBtnItem" v-on:click="closePaperResult">
					<div class="popContent">
						<div class="testing_pop re">
							<div class="count center ab">{{this.score}}</div>
							<img src="//images.jinku.com/newjk/h5/images/mobile/pop/testing/icon02.png" class="pic02">
							<div class="center">
								<a class="pointer testBtnItem testBtnItem01 radius3" v-on:click="continueExam">继续挑战</a>
								<a class="pointer testBtnItem testBtnItem02 radius3" v-on:click="paperAnalysis">查看解析</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--试卷未通过-->

			<!--试卷通过-->
			<div class="testingResult publicPop pop16" style="display: block;" v-show="this.paperSuccess">
				<div class="popContainer" style="margin-left: -182px; margin-top: -201px;">
					<input type="button" class="closeBtnItem" v-on:click="closePaperResult">
					<div class="popContent">
						<div class="testing_pop re">
							<img src="//images.jinku.com/newjk/h5/images/mobile/pop/testing/icon01.png" class="pic01">
							<div class="ab scoreEle"></div>
							<div class="ab resultText center">
								您已成功解锁新的技能等级， 请<a href="/cp-result">点击查看</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--试卷通过-->



		</div>




</template>

<script>
    import http from "../../lib/http";
    import common from "../../lib/common";

    export default {
        name: 'DoPaper',
        data() {
            return {
                'token': '',
                'showPaper': false, //控制页面显示隐藏
				'curId': 0, //当前试题索引id
                'paperId': 0, //试卷id
				'finishNum': 0, //已完成试题数量
				'totalNum': 0, //总试题数量
				'timer': '00:30:00',
				'surplusSecodes': 0, //剩余的秒数
				'questionList' : [], //问题list
				'questionIdArr': [], //问题id arr
				'answerResult': {}, //选择答案结果对象
				'score': 0, //试卷得分
				'isUpgrade': 0, //是否升级成功
				'paperFail': false, //考试失败
				'paperSuccess': false, //考试成功
            }
        },
        methods: {
            getPaperId:function(){
                var url = window.location.href;
                var param = url.split('?')[1];
				var paramArr = param.split('&');
				for (var num = 0; num < paramArr.length; num++){
				    var tmpArr = paramArr[num].split('=');
				    if (tmpArr[0] == 'paper_id'){
						this.paperId = tmpArr[1];
					}
				}
            },
            getPaperInfo:function () {
                let self = this;
                this.getPaperId();
                if (!this.paperId){
                    alert("试卷错误，请稍后重试");
                    this.$router.push('/');
                    return false;
				}
				this.token = common.getToken();
                //ajax 调用接口获取
                http({method: "post", url: "/org/exam/get-paper-info", data: "token="+encodeURIComponent(this.token)+"&paper_id="+this.paperId}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){ //
                        self.totalNum = res.data.paper_total;
                        self.setSurplusSeconds(res.data.paper_start);
						self.questionList = res.data.question_info;
						//循环问题
						for (var i = 0;i < self.questionList.length; i++){
						    self.questionIdArr.push(self.questionList[i].question_id);
						}

                        self.showPaper = true;
                    } else { //接口错误，跳转到节点页面
                        alert("试卷错误，请稍后重试");
                        self.$router.push('/');
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    alert("试卷错误，请稍后重试");
                    self.$router.push('/');
                });

            },
			setSurplusSeconds:function (startTime) {
                //let currTimestamp = Date.parse(new Date())/1000;
                //let seconds = currTimestamp - startTime; //开始的秒数
				let surplusSecodes = 1800; //1800 - seconds;  //倒计时30分钟
				if (surplusSecodes < 0){
                    surplusSecodes = 0;
				}
				this.surplusSecodes = surplusSecodes;
                setInterval(this.setTimer, 1000);
            },
			setTimer:function () {
                this.surplusSecodes = this.surplusSecodes - 1;
                if (this.surplusSecodes < 0){
                    this.surplusSecodes = 0;
				}
                let minute = Math.floor(this.surplusSecodes/60);
                if (minute < 10){
                    minute = '0'+minute;
				}
                let seconds = this.surplusSecodes%60;
                if (seconds < 10){
                    seconds = '0'+seconds;
				}
                this.timer = '00:'+minute+":"+seconds;
            },
            selQuestion:function (idx) {
				this.curId = idx;
            },
            setOption:function (qid, poid) {
				var list = document.getElementsByClassName('t');
				for (var i = 0;i < list.length; i++){
					if (qid == list[i].getAttribute('qid')){ //当前Ul
					    var liArr = list[i].getElementsByTagName('li');
					    for (var j = 0; j < liArr.length; j++){
                            liArr[j].className = "re radius3 radioItemEvent";
						}
						break;
					}
				}
				document.getElementById(poid).className = 're radius3 radioItemEvent active';

				//组装答案对象
				this.answerResult[qid] = poid;
				//设置答题卡样式
				let answerList = document.getElementsByClassName('answer_sheet');
				for (var k = 0; k < answerList.length; k++){
				    if (qid == answerList[k].getAttribute('ans_qid')){
                        answerList[k].className = "fl radius2 answer_sheet";
                        break;
					}
				}
				//更新已完成题目数量
                let answerLen = Object.keys(this.answerResult).length;
				if (answerLen > 0){
				    this.finishNum = answerLen;
				}
				//下一题
				setTimeout(this.nextQuestion, 300);
				//this.nextQuestion();
            },
			nextQuestion:function () {
				if (this.curId < (this.totalNum - 1)){
				    this.curId += 1;
				}
            },
            submitPaper:function () {
                let self = this;
                let answerLen = Object.keys(this.answerResult).length;
                if (answerLen < this.totalNum){
                    alert("请完成所有题目");
                    return false;
				}
				let answerStr = JSON.stringify(this.answerResult);
				//ajax调用提交答案接口
                http({method: "post", url: "/org/exam/finish-paper", data: "token="+encodeURIComponent(this.token)+"&paper_id="+this.paperId+'&answer='+encodeURIComponent(answerStr)}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){
						self.score = res.data.score;
						self.isUpgrade = res.data.is_upgrade;
						self.paperResult(); //显示试卷结果
                    } else { //接口错误，跳转到节点页面
                        alert("提交试卷错误，请稍后重试");
                        self.$router.push('/');
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    alert("提交试卷错误，请稍后重试");
                    self.$router.push('/');
                });
            },
			paperResult:function () {
				if (this.score > 60){ //考试成功
				    this.paperSuccess = true;
				} else { //考试失败
				    this.paperFail = true;
				}
            },
            closePaperResult:function () {
                this.paperSuccess = false;
                this.paperFail = false;
                this.$router.push('/cp-result');
            },
            continueExam:function () {
                let self = this;
                //ajax 创建试卷
                http({method: "post", url: "/org/exam/create-paper", data: "token="+encodeURIComponent(this.token)}).then(function (res) {
                    //处理登录返回结果
                    if (res.code == 0){
						location.href = '/do-paper?paper_id='+res.data.paper_id;
                    } else { //接口错误，跳转到节点页面
                        alert("创建试卷错误，请稍后重试");
                        self.$router.push('/');
                    }
                }).catch(function (err) {
                    //处理结果异常捕获
                    alert("创建试卷错误，请稍后重试");
                    self.$router.push('/');
                });
            },
            paperAnalysis:function () {
				this.$router.push('/paper-analysis?paper_id='+this.paperId);
            }
        },
        created(){
            this.getPaperInfo();
        },

    }

</script>

<style scoped>
@import "//images.jinku.com/newjk/h5/css/global_mobile.css";
@import "//images.jinku.com/newjk/h5/css/public.css";
@import "//images.jinku.com/newjk/h5/css/testing.css";
@import "//images.jinku.com/newjk/h5/css/mobile_pop.css?v=1_1";
</style>



// WEBPACK FOOTER //
// src/components/exam/do-paper.vue